const requests = {
  'nav.requests': 'Anträge',
  'requests.title': 'Anträge',
  'requests.new': 'Antrag stellen',
  'requests.type.URLAUB': 'Urlaub',
  'requests.type.FZT': 'FZT',
  'requests.form.type': 'Antragsart',
  'requests.form.titleFzt': 'Neuer FZT-Antrag (Freizeitausgleich)',
  'requests.form.substituteMandatoryHintFzt': 'Dein Team verlangt für FZT-Anträge eine Vertretung aus dem Team.',
  'requests.col.type': 'Art',
  'requests.my.title': 'Meine Anträge',
  'requests.team.title': 'Anträge meines Teams',
  'requests.fzt.quota': 'FZT-Kontingent {year}',
  'requests.fzt.total': 'Gesamt',
  'requests.fzt.used': 'Genommen / beantragt',
  'requests.fzt.available': 'Verfügbar',
};

export default requests;
